import zSchema from "z-schema"
let validator = new zSchema()



import config from './JSON/schema.config.json'
export function isValid_config(object) {
    return validator.validate(object, config)
}